module.exports = "<sc-fact-slider model=\"model\" filter=\"filter\" filter-data=\"filterData\" selected-fact=\"selectedFact\"></sc-fact-slider>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/slider/facts-slider-modal.component.html
// module id = 323
// module chunks = 0